import { VALID_THREADS_TOPIC_REGEX } from 'later/utils/constants';

/**
 * Extracts valid Threads topics (hashtags) from a given caption.
 * Threads only allows at most one topic, but this function may return more than one,
 * which is why it is not exported.
 *
 * @param {string} caption - The caption from which to extract topics.
 * @returns {string[]} An array of Threads topics found in the caption. Empty if none found.
 */
function extractThreadsTopics(caption: string): string[] {
  return caption.match(new RegExp(VALID_THREADS_TOPIC_REGEX, 'g')) || [];
}

/**
 * Extracts the valid Threads topic (hashtag) from a given caption.
 * If no valid topic is found, it returns null.
 *
 * @param {string} caption - The caption from which to extract the topic.
 * @returns {string | null} The valid Threads topic, or null if none found.
 */
export function extractThreadsTopic(caption: string): string | null {
  const topics = extractThreadsTopics(caption);
  return topics.length > 0 ? topics[0] : null;
}

/**
 * Counts the number of valid Threads topics (hashtags) in a given caption.
 * The only valid numbers are 0 or 1, as Threads allows at most one topic.
 *
 * @param {string} caption - The caption from which to count topics.
 * @returns {number} The count of Threads topics found in the caption.
 */
export function countThreadsTopics(caption: string): number {
  return extractThreadsTopics(caption).length;
}

export default extractThreadsTopic;
